import type { CSSProperties } from "react";
import type { SponsorCampaign } from "./campaignTypes";

export const portalFont =
  '"Inter", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif';

export const PORTAL_MAX_WIDTH = 1420;

export const portalTokens = {
  background: "#0a0a0a",
  surface: "#121417",
  surfaceRaised: "#1a1d22",
  border: "rgba(255,255,255,0.10)",
  text: "#F4F5F7",
  textMuted: "#A7ADB7",
  radius: "28px",
  radiusSm: "16px",
} as const;

export function portalCssVars(accent: string): CSSProperties {
  return {
    ["--portal-accent" as string]: accent,
    ["--portal-background" as string]: portalTokens.background,
    ["--portal-surface" as string]: portalTokens.surface,
    ["--portal-surface-raised" as string]: portalTokens.surfaceRaised,
    ["--portal-border" as string]: portalTokens.border,
    ["--portal-text" as string]: portalTokens.text,
    ["--portal-text-muted" as string]: portalTokens.textMuted,
    ["--portal-radius" as string]: portalTokens.radius,
    ["--portal-font" as string]: portalFont,
  };
}

export function portalShellSx(campaign: SponsorCampaign) {
  return {
    ...portalCssVars(campaign.accentColor),
    bgcolor: "var(--portal-background)",
    color: "var(--portal-text)",
    fontFamily: portalFont,
    minHeight: "100vh",
    overflowX: "hidden" as const,
  };
}

export const eyebrowSx = {
  fontFamily: portalFont,
  fontSize: "0.75rem",
  fontWeight: 600,
  letterSpacing: "0.16em",
  textTransform: "uppercase" as const,
  color: "var(--portal-text-muted)",
  mb: 1.25,
};

export const sectionTitleSx = {
  fontFamily: portalFont,
  fontWeight: 700,
  color: "var(--portal-text)",
  fontSize: "clamp(1.75rem, 2.4vw + 1rem, 2.75rem)",
  lineHeight: 1.12,
  letterSpacing: "-0.02em",
  mb: 1.5,
};

export const bodySx = {
  fontFamily: portalFont,
  color: "var(--portal-text-muted)",
  fontSize: { xs: "0.9375rem", md: "1.0625rem" },
  lineHeight: 1.65,
};

export const cardSurfaceSx = {
  bgcolor: "var(--portal-surface)",
  border: "1px solid var(--portal-border)",
  borderRadius: "var(--portal-radius)",
};
